import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import ProductListPage from './pages/ProductListPage';
import ProductDetailPage from './pages/ProductDetailPage';
import PerformanceComparisonPage from './pages/PerformanceComparisonPage';
import RankingAnalysisPage from './pages/RankingAnalysisPage';
import RankingHealthCheckPage from './pages/RankingHealthCheckPage';
import SalesMonitoringPage from './pages/SalesMonitoringPage';
import PriceChangesPage from './pages/PriceChangesPage';
import StockForecastPage from './pages/StockForecastPage';
import RankingSimulatorPage from './pages/RankingSimulatorPage';
import BasketAnalysisPage from './pages/BasketAnalysisPage';
import SemanticSearchPage from './pages/SemanticSearchPage';
import ReplenishmentPage from './pages/ReplenishmentPage';
import ReplenishmentCatalogPage from './pages/ReplenishmentCatalogPage';
import StockTransfersPage from './pages/StockTransfersPage';
import StockTrucksPage from './pages/StockTrucksPage';
import ReplenishmentPromotionsPage from './pages/ReplenishmentPromotionsPage';
import ReplenishmentMissingPage from './pages/ReplenishmentMissingPage';
import LoginPage from './pages/LoginPage';
import AdminApiKeysPage from './pages/AdminApiKeysPage';
import { AuthProvider } from './contexts/AuthContext';
import { RequireAuth, RequireStaff } from './components/RequireAuth';
import './App.css';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <div className="App">
          <Navbar />
          <main className="container-fluid mt-3">
            <Routes>
              {/* Login (público) */}
              <Route path="/login" element={<LoginPage />} />

              {/* Páginas protegidas (sessão) */}
              <Route path="/" element={<RequireAuth><HomePage /></RequireAuth>} />
              <Route path="/products" element={<RequireAuth><ProductListPage /></RequireAuth>} />
              <Route path="/products/:sku" element={<RequireAuth><ProductDetailPage /></RequireAuth>} />
              <Route path="/performance-comparison" element={<RequireAuth><PerformanceComparisonPage /></RequireAuth>} />
              <Route path="/ranking-analysis" element={<RequireAuth><RankingAnalysisPage /></RequireAuth>} />
              <Route path="/ranking-health" element={<RequireAuth><RankingHealthCheckPage /></RequireAuth>} />
              <Route path="/sales-monitoring" element={<RequireAuth><SalesMonitoringPage /></RequireAuth>} />
              <Route path="/price-changes" element={<RequireAuth><PriceChangesPage /></RequireAuth>} />
              <Route path="/stock-forecast" element={<RequireAuth><StockForecastPage /></RequireAuth>} />
              <Route path="/ranking-simulator" element={<RequireAuth><RankingSimulatorPage /></RequireAuth>} />
              <Route path="/basket-analysis" element={<RequireAuth><BasketAnalysisPage /></RequireAuth>} />
              <Route path="/semantic-search" element={<RequireAuth><SemanticSearchPage /></RequireAuth>} />

              <Route path="/replenishment" element={<RequireAuth><ReplenishmentPage /></RequireAuth>} />
              <Route path="/replenishment/promocoes" element={<RequireAuth><ReplenishmentPromotionsPage /></RequireAuth>} />
              <Route path="/replenishment/produtos-em-falta" element={<RequireAuth><ReplenishmentMissingPage /></RequireAuth>} />
              <Route path="/replenishment/catalogacao" element={<RequireAuth><ReplenishmentCatalogPage /></RequireAuth>} />

              <Route path="/stock/transferencias" element={<RequireAuth><StockTransfersPage /></RequireAuth>} />
              <Route path="/stock/camioes" element={<RequireAuth><StockTrucksPage /></RequireAuth>} />

              {/* Admin (staff) — fora de /admin para não colidir com o Django admin no nginx */}
              <Route path="/api-keys" element={<RequireStaff><AdminApiKeysPage /></RequireStaff>} />
            </Routes>
          </main>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
